export default __webpack_public_path__ + "static/media/ac_crd.995272f8.bmp";